/* The words use a 12-second cycle; the explanations follow native page scrolling. */
if (!customElements.get('solid-benefits')) {
  customElements.define('solid-benefits', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const { signal } = this.abort;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = false;
      this.index = 0;
      this.words = [...this.querySelectorAll('[data-benefit-word]')];
      this.items = [...this.querySelectorAll('.sd-benefits-item')];
      this.lines = [...this.querySelectorAll('[data-benefit-line]')];
      this.updateLines = () => {
        const start = innerHeight * .40;
        const distance = innerHeight * .10;
        this.items.forEach((item, i) => {
          const progress = this.reduced.matches || this.paused ? 1 : Math.max(0, Math.min(1, (start - item.getBoundingClientRect().top) / distance));
          this.lines[i].style.opacity = progress;
        });
      };
      this.queueLines = () => {
        if (this.lineFrame) return;
        this.lineFrame = requestAnimationFrame(() => {
          this.lineFrame = 0;
          this.updateLines();
        });
      };
      window.addEventListener('scroll', this.queueLines, { signal, passive: true });
      window.addEventListener('resize', this.queueLines, { signal, passive: true });
      this.reduced.addEventListener('change', () => this.configure(), { signal });
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        this.scheduleWord();
      });
      this.observer.observe(this);
      document.addEventListener('visibilitychange', () => this.scheduleWord(), { signal });
      this.addEventListener('shopify:block:select', () => {
        this.paused = true;
        this.configure();
      }, { signal });
      this.configure();
    }
    configure() {
      this.media?.revert();
      this.wordAnimations?.forEach(animation => animation.cancel());
      this.words.forEach((word, i) => { word.style.opacity = i === this.index ? '1' : '0'; });
      if (!this.paused && !this.reduced.matches && window.gsap && window.ScrollTrigger) {
        const { gsap, ScrollTrigger } = window;
        gsap.registerPlugin(ScrollTrigger);
        this.media = gsap.matchMedia();
        this.media.add({ mobile: '(max-width: 749px)', desktop: '(min-width: 750px)' }, context => {
          const bodies = [...this.querySelectorAll('[data-benefit-description]')];
          const timeline = gsap.timeline({ onUpdate: this.updateLines, scrollTrigger: {
            trigger: this, start: context.conditions.mobile ? 'top 42%' : 'top 60%',
            end: context.conditions.mobile ? 'top -10%' : 'top 18%', scrub: .35,
            invalidateOnRefresh: true
          }});
          bodies.forEach((body, i) => {
            timeline.fromTo(body, { height: 0, opacity: 0 }, { height: () => body.firstElementChild.offsetHeight, opacity: 1, duration: 1, ease: 'none' }, i * .7);
          });
        });
      }
      this.queueLines();
      this.scheduleWord();
    }
    scheduleWord() {
      clearTimeout(this.timer);
      if (!this.inView || this.paused || this.reduced.matches || document.hidden || this.words.length < 2) return;
      this.timer = setTimeout(() => {
        const previous = this.words[this.index];
        this.index = (this.index + 1) % this.words.length;
        const next = this.words[this.index];
        previous.style.opacity = '0';
        next.style.opacity = '1';
        this.wordAnimations = [
          previous.animate([{ opacity: 1, transform: 'translateY(0)' }, { opacity: 0, transform: 'translateY(-5px)' }], { duration: 260, easing: 'ease-out' }),
          next.animate([{ opacity: 0, transform: 'translateY(5px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 360, easing: 'ease-out' })
        ];
        this.scheduleWord();
      }, 4000);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      cancelAnimationFrame(this.lineFrame);
      this.wordAnimations?.forEach(animation => animation.cancel());
      this.observer?.disconnect();
      this.abort?.abort();
      this.media?.revert();
    }
  });
}
